import authBaseHttpRequest from './authBaseHttpRequest';

export const dashboardOverview = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/overview/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const dashboardMissedShiftRatio = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/missed-shift-ratio/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getDashboardTotalValueEarnedData = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/total-value-earned/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getDashboardLiveDailyTrackerData = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/live-daily-tracker/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getDashboardProductivityScoreData = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/productivity-score/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getDashboardTrainingGraphData = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/training-graph/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getDashboardAvgTenureData = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/avg-tenure/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getDashboardGraphOptions = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/graphs/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getCaregiverIncentiveUtilization = ({ fromDate, toDate, branchName }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/caregiver-incentive-utilization/?branchName=${branchName}&from_date=${fromDate}&to_date=${toDate}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getCaregiverIncentiesBranchList = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/branch_list/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getTopFourRewards = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/top-reward-redemptions/`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getAgencyList = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/dashboard/stats/agency-list/',
    headers: {
      'Content-Type': 'application/json',
      },
    })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));};

export const getSendCareCoinsEnabled = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/dashboard/send-care-coins-enabled/',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getBalanceStatus = ({ agency }) => {
  return authBaseHttpRequest({
    method: 'get',
    url: `/dashboard/stats/balance-status/?agency=${agency}`,
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
